import {metadaApi} from '@dms/api/base';

import {
  PostIntegrationsForXentryLinkApiResponse,
  PostIntegrationsForXentryLinkApiArg,
  PostIntegrationsForXentryUnlinkApiResponse,
  PostIntegrationsForXentryUnlinkApiArg,
  PostAvailableXentryOrdersApiResponse,
  PostAvailableXentryOrdersApiArg,
  GetServiceCaseIntegrationsApiResponse,
  GetServiceCaseIntegrationsApiArg,
  PostServiceOrderAudatexTaskCalculationsApiResponse,
  PostServiceOrderAudatexTaskCalculationsApiArg,
  PostServiceOrderMyClaimCalculationsApiResponse,
  PostServiceOrderMyClaimCalculationsApiArg,
  PostIntegrationsForXentryLinkApiResponseSchema,
  PostIntegrationsForXentryLinkApiArgSchema,
  PostIntegrationsForXentryUnlinkApiResponseSchema,
  PostIntegrationsForXentryUnlinkApiArgSchema,
  PostAvailableXentryOrdersApiResponseSchema,
  PostAvailableXentryOrdersApiArgSchema,
  GetServiceCaseIntegrationsApiResponseSchema,
  GetServiceCaseIntegrationsApiArgSchema,
  PostServiceOrderAudatexTaskCalculationsApiResponseSchema,
  PostServiceOrderAudatexTaskCalculationsApiArgSchema,
  PostServiceOrderMyClaimCalculationsApiResponseSchema,
  PostServiceOrderMyClaimCalculationsApiArgSchema,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiResponse,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiArg,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiResponseSchema,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiArgSchema,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponse,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiArg,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponseSchema,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiArgSchema,
  GetAudatexCalculationsUserSettingsApiArg,
  GetAudatexCalculationsUserSettingsApiResponse,
  GetMyClaimCalculationsUserSettingsApiArg,
  GetMyClaimCalculationsUserSettingsApiResponse,
  GetMyClaimCalculationsUserSettingsApiResponseSchema,
  GetMyClaimCalculationsUserSettingsApiArgSchema,
  GetAudatexCalculationsUserSettingsApiResponseSchema,
  GetAudatexCalculationsUserSettingsApiArgSchema,
  GetServiceCaseIntegrationsClaraVehicleDetailsApiResponse,
  GetServiceCaseIntegrationsClaraVehicleDetailsApiArg,
  GetServiceCaseIntegrationsClaraClaimDetailApiArg,
  GetServiceCaseIntegrationsClaraClaimDetailApiResponse,
  GetServiceCaseIntegrationsClaraClaimApiArg,
  GetServiceCaseIntegrationsClaraClaimApiResponse,
  GetServiceCaseIntegrationsClaraClaimApiResponseSchema,
  GetServiceCaseIntegrationsClaraClaimApiArgSchema,
  GetServiceCaseIntegrationsClaraClaimDetailApiArgSchema,
  GetServiceCaseIntegrationsClaraClaimDetailApiResponseSchema,
  PostServiceCaseIntegrationsClaraClaimApiArg,
  PostServiceCaseIntegrationsClaraClaimApiResponse,
  PostServiceCaseIntegrationsClaraClaimApiArgSchema,
  PostServiceCaseIntegrationsClaraClaimApiResponseSchema,
  GetServiceOrderIntegrationClaraInformationApiArgSchema,
  GetServiceOrderIntegrationClaraInformationApiArg,
  GetServiceOrderIntegrationClaraInformationApiResponse,
  GetServiceOrderIntegrationClaraInformationApiResponseSchema,
  PatchServiceOrderIntegrationClaraInformationApiArgSchema,
  PatchServiceOrderIntegrationClaraInformationApiResponseSchema,
  PatchServiceOrderIntegrationClaraInformationApiArg,
  PatchServiceOrderIntegrationClaraInformationApiResponse,
  GetServiceWorkItemIntegrationClaraInformationApiArgSchema,
  GetServiceWorkItemIntegrationClaraInformationApiResponseSchema,
  GetServiceWorkItemIntegrationClaraInformationApiArg,
  GetServiceWorkItemIntegrationClaraInformationApiResponse,
  PatchServiceWorkItemIntegrationClaraInformationApiResponseSchema,
  PatchServiceWorkItemIntegrationClaraInformationApiArg,
  PatchServiceWorkItemIntegrationClaraInformationApiResponse,
  PatchServiceWorkItemIntegrationClaraInformationApiArgSchema,
  GetServiceMaterialItemIntegrationClaraInformationApiArgSchema,
  GetServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
  GetServiceMaterialItemIntegrationClaraInformationApiArg,
  GetServiceMaterialItemIntegrationClaraInformationApiResponse,
  PatchServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
  PatchServiceMaterialItemIntegrationClaraInformationApiArgSchema,
  PatchServiceMaterialItemIntegrationClaraInformationApiResponse,
  PatchServiceMaterialItemIntegrationClaraInformationApiArg,
  GetServiceOrderIntegrationXentryInformationApiResponse,
  GetServiceOrderIntegrationXentryInformationApiArg,
  GetServiceOrderIntegrationXentryInformationApiResponseSchema,
  GetServiceOrderIntegrationXentryInformationApiArgSchema,
  PatchServiceOrderIntegrationXentryInformationApiResponse,
  PatchServiceOrderIntegrationXentryInformationApiArg,
  PatchServiceOrderIntegrationXentryInformationApiResponseSchema,
  PatchServiceOrderIntegrationXentryInformationApiArgSchema,
  GetIntegrationCustomerApiResponse,
  GetIntegrationCustomerApiArg,
  GetIntegrationCustomerApiResponseSchema,
  GetIntegrationCustomerApiArgSchema,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponse,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiArg,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponseSchema,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiArgSchema,
  GetServiceCaseIntegrationsEvaClaimDetailApiResponse,
  GetServiceCaseIntegrationsEvaClaimDetailApiArg,
  PostServiceCaseIntegrationsEvaClaimExportApiArg,
  PostServiceCaseIntegrationsEvaClaimExportApiResponse,
  GetServiceCaseIntegrationsEvaClaimDetailApiArgSchema,
  GetServiceCaseIntegrationsEvaClaimDetailApiResponseSchema,
  PostServiceCaseIntegrationsEvaClaimExportApiArgSchema,
  PostServiceCaseIntegrationsEvaClaimExportApiResponseSchema,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
} from './types';

const metadaWorkshopIntegrationApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postIntegrationsForXentryLink: build.mutation<
      PostIntegrationsForXentryLinkApiResponse,
      PostIntegrationsForXentryLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-order-link`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'serviceJobs', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrderJobs',
      ],
      extraOptions: {
        responseSchema: PostIntegrationsForXentryLinkApiResponseSchema,
        requestSchema: PostIntegrationsForXentryLinkApiArgSchema,
      },
    }),
    postIntegrationsForXentryUnlink: build.mutation<
      PostIntegrationsForXentryUnlinkApiResponse,
      PostIntegrationsForXentryUnlinkApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-order-unlink`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'serviceJobs', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrderJobs',
      ],
      extraOptions: {
        responseSchema: PostIntegrationsForXentryUnlinkApiResponseSchema,
        requestSchema: PostIntegrationsForXentryUnlinkApiArgSchema,
      },
    }),
    postAvailableXentryOrders: build.mutation<
      PostAvailableXentryOrdersApiResponse,
      PostAvailableXentryOrdersApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-orders`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostAvailableXentryOrdersApiResponseSchema,
        requestSchema: PostAvailableXentryOrdersApiArgSchema,
      },
    }),
    getServiceCaseIntegrations: build.query<
      GetServiceCaseIntegrationsApiResponse,
      GetServiceCaseIntegrationsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integrations`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsApiArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
    }),
    postServiceOrderAudatexTaskCalculations: build.mutation<
      PostServiceOrderAudatexTaskCalculationsApiResponse,
      PostServiceOrderAudatexTaskCalculationsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/audatex-task-calculations`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
        {type: 'serviceOrderJobs', id: queryArg.serviceOrderId},
        {type: 'serviceOrderTotalAmount', id: queryArg.serviceOrderId},
        {type: 'orderProfitability', id: queryArg.serviceOrderId},
        {type: 'serviceCase', id: queryArg.serviceCaseId},
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
        'serviceOrderJobTotalAmount',
        'checkout',
        'audatexCalculationsUserSettings',
        'afsCheckout',
        'afsPaymentsList',
      ],
      extraOptions: {
        responseSchema: PostServiceOrderAudatexTaskCalculationsApiResponseSchema,
        requestSchema: PostServiceOrderAudatexTaskCalculationsApiArgSchema,
      },
    }),
    postServiceOrderMyClaimCalculations: build.mutation<
      PostServiceOrderMyClaimCalculationsApiResponse,
      PostServiceOrderMyClaimCalculationsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/myclaim-calculations`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
        {type: 'serviceOrderJobs', id: queryArg.serviceOrderId},
        {type: 'serviceOrderTotalAmount', id: queryArg.serviceOrderId},
        {type: 'orderProfitability', id: queryArg.serviceOrderId},
        {type: 'serviceCase', id: queryArg.serviceCaseId},
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
        'serviceOrderJobTotalAmount',
        'checkout',
        'myClaimCalculationsUserSettings',
        'afsCheckout',
        'afsPaymentsList',
      ],
      extraOptions: {
        responseSchema: PostServiceOrderMyClaimCalculationsApiResponseSchema,
        requestSchema: PostServiceOrderMyClaimCalculationsApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsXentryOrderManualCreation: build.mutation<
      PostServiceCaseIntegrationsXentryOrderManualCreationApiResponse,
      PostServiceCaseIntegrationsXentryOrderManualCreationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-order-manual-creation`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'serviceJobs', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrderJobs',
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsXentryOrderManualCreationApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsXentryOrderManualCreationApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsXentryOrderSynchronizationApi: build.mutation<
      PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponse,
      PostServiceCaseIntegrationsXentryOrderSynchronizationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/service-case/${queryArg.serviceCaseId}/integration/xentry-order-synchronize`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'checkIn', id: queryArg.serviceCaseId},
        {type: 'handOver', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrder',
        'serviceOrderJobs',
        'serviceOrderTotalAmount',
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
        'serviceOrderJobTotalAmount',
        'orderProfitability',
        'serviceOrderJobs',
        'checkout',
        'afsCheckout',
        'afsPaymentsList',
        'serviceJobActions',
        {type: 'serviceActions', id: queryArg.serviceCaseId},
        'orderActions',
        'serviceOrderCheckoutRestriction',
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsXentryOrderSynchronizationApiArgSchema,
      },
    }),
    getAudatexCalculationsUserSettings: build.query<
      GetAudatexCalculationsUserSettingsApiResponse,
      GetAudatexCalculationsUserSettingsApiArg
    >({
      query: () => ({
        url: `/service/v1/integration/audatex-calculations-user-settings`,
      }),
      providesTags: () => [{type: 'audatexCalculationsUserSettings'}],
      extraOptions: {
        responseSchema: GetAudatexCalculationsUserSettingsApiResponseSchema,
        requestSchema: GetAudatexCalculationsUserSettingsApiArgSchema,
      },
    }),
    getMyClaimCalculationsUserSettings: build.query<
      GetMyClaimCalculationsUserSettingsApiResponse,
      GetMyClaimCalculationsUserSettingsApiArg
    >({
      query: () => ({
        url: `/service/v1/integration/myclaim-calculations-user-settings`,
      }),
      providesTags: () => ['myClaimCalculationsUserSettings'],
      extraOptions: {
        responseSchema: GetMyClaimCalculationsUserSettingsApiResponseSchema,
        requestSchema: GetMyClaimCalculationsUserSettingsApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsClaraVehicleDetails: build.query<
      GetServiceCaseIntegrationsClaraVehicleDetailsApiResponse,
      GetServiceCaseIntegrationsClaraVehicleDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/clara-vehicle-info`,
      }),
    }),
    getServiceCaseIntegrationsClaraClaim: build.query<
      GetServiceCaseIntegrationsClaraClaimApiResponse,
      GetServiceCaseIntegrationsClaraClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-claim`,
      }),
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsClaraClaimApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsClaraClaimApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsClaraClaim: build.mutation<
      PostServiceCaseIntegrationsClaraClaimApiResponse,
      PostServiceCaseIntegrationsClaraClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-claim`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsClaraClaimApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsClaraClaimApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsClaraClaimDetail: build.query<
      GetServiceCaseIntegrationsClaraClaimDetailApiResponse,
      GetServiceCaseIntegrationsClaraClaimDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-claim-detail`,
      }),
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsClaraClaimDetailApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsClaraClaimDetailApiArgSchema,
      },
    }),
    getServiceOrderIntegrationClaraInformation: build.query<
      GetServiceOrderIntegrationClaraInformationApiResponse,
      GetServiceOrderIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationClaraInformationApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationClaraInformationApiArgSchema,
      },
    }),
    patchServiceOrderIntegrationClaraInformation: build.mutation<
      PatchServiceOrderIntegrationClaraInformationApiResponse,
      PatchServiceOrderIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: PatchServiceOrderIntegrationClaraInformationApiResponseSchema,
        requestSchema: PatchServiceOrderIntegrationClaraInformationApiArgSchema,
      },
    }),
    getServiceWorkItemIntegrationClaraInformation: build.query<
      GetServiceWorkItemIntegrationClaraInformationApiResponse,
      GetServiceWorkItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-work/${queryArg.serviceItemId}/integration/clara-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'workItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: GetServiceWorkItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: GetServiceWorkItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    patchServiceWorkItemIntegrationClaraInformation: build.mutation<
      PatchServiceWorkItemIntegrationClaraInformationApiResponse,
      PatchServiceWorkItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-work/${queryArg.serviceItemId}/integration/clara-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'workItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: PatchServiceWorkItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: PatchServiceWorkItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    getServiceMaterialItemIntegrationClaraInformation: build.query<
      GetServiceMaterialItemIntegrationClaraInformationApiResponse,
      GetServiceMaterialItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-material/${queryArg.serviceItemId}/integration/clara-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'materialItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: GetServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: GetServiceMaterialItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    patchServiceMaterialItemIntegrationClaraInformation: build.mutation<
      PatchServiceMaterialItemIntegrationClaraInformationApiResponse,
      PatchServiceMaterialItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-material/${queryArg.serviceItemId}/integration/clara-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'materialItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: PatchServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: PatchServiceMaterialItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    getServiceOrderIntegrationXentryInformation: build.query<
      GetServiceOrderIntegrationXentryInformationApiResponse,
      GetServiceOrderIntegrationXentryInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/xentry-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationXentryInformationApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationXentryInformationApiArgSchema,
      },
    }),
    patchServiceOrderIntegrationXentryInformation: build.mutation<
      PatchServiceOrderIntegrationXentryInformationApiResponse,
      PatchServiceOrderIntegrationXentryInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/xentry-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
        {type: 'serviceCase', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PatchServiceOrderIntegrationXentryInformationApiResponseSchema,
        requestSchema: PatchServiceOrderIntegrationXentryInformationApiArgSchema,
      },
    }),
    getIntegrationCustomer: build.query<
      GetIntegrationCustomerApiResponse,
      GetIntegrationCustomerApiArg
    >({
      query: (queryArg) => ({
        headers: {
          Accept: 'application/pdf',
        },
        url: `/integration/v1/integration/${queryArg.customerId}`,
        responseHandler: async (response) => {
          const blob = await response.blob();
          return blob.size ? window.URL.createObjectURL(blob) : null;
        },
      }),
      keepUnusedDataFor: 0, // Disable cache for PDF data
      extraOptions: {
        responseSchema: GetIntegrationCustomerApiResponseSchema,
        requestSchema: GetIntegrationCustomerApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsXentrySynchronizationStatus: build.query<
      GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponse,
      GetServiceCaseIntegrationsXentrySynchronizationStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/service-case/${queryArg.serviceCaseId}/integration/xentry-synchronization-status`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsXentrySynchronizationStatusApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsEvaClaimDetail: build.query<
      GetServiceCaseIntegrationsEvaClaimDetailApiResponse,
      GetServiceCaseIntegrationsEvaClaimDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/eva-claim`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'evaClaimDetail', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsEvaClaimDetailApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsEvaClaimDetailApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsEvaClaimExport: build.mutation<
      PostServiceCaseIntegrationsEvaClaimExportApiResponse,
      PostServiceCaseIntegrationsEvaClaimExportApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/eva-claim-export`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'evaClaimDetail', id: queryArg.serviceCaseId},
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsEvaClaimExportApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsEvaClaimExportApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsEvaClaimAdditionalInformation: build.query<
      GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
      GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/eva-additional-information`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'evaClaimAdditionalInformation',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
      },
    }),
    patchServiceCaseIntegrationsEvaClaimAdditionalInformation: build.mutation<
      PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
      PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/eva-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {
          type: 'evaClaimAdditionalInformation',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
        requestSchema: PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
      },
    }),
  }),
});

export const {
  usePostIntegrationsForXentryLinkMutation,
  usePostIntegrationsForXentryUnlinkMutation,
  usePostAvailableXentryOrdersMutation,
  useGetServiceCaseIntegrationsQuery,
  usePostServiceOrderAudatexTaskCalculationsMutation,
  usePostServiceOrderMyClaimCalculationsMutation,
  usePostServiceCaseIntegrationsXentryOrderManualCreationMutation,
  usePostServiceCaseIntegrationsXentryOrderSynchronizationApiMutation,
  useGetAudatexCalculationsUserSettingsQuery,
  useGetMyClaimCalculationsUserSettingsQuery,
  useGetServiceCaseIntegrationsClaraVehicleDetailsQuery,
  useGetServiceCaseIntegrationsClaraClaimQuery,
  usePostServiceCaseIntegrationsClaraClaimMutation,
  useGetServiceCaseIntegrationsClaraClaimDetailQuery,
  useGetServiceOrderIntegrationClaraInformationQuery,
  usePatchServiceOrderIntegrationClaraInformationMutation,
  useGetServiceWorkItemIntegrationClaraInformationQuery,
  usePatchServiceWorkItemIntegrationClaraInformationMutation,
  useGetServiceMaterialItemIntegrationClaraInformationQuery,
  usePatchServiceMaterialItemIntegrationClaraInformationMutation,
  useGetServiceOrderIntegrationXentryInformationQuery,
  usePatchServiceOrderIntegrationXentryInformationMutation,
  useGetIntegrationCustomerQuery,
  useGetServiceCaseIntegrationsXentrySynchronizationStatusQuery,
  useGetServiceCaseIntegrationsEvaClaimDetailQuery,
  usePostServiceCaseIntegrationsEvaClaimExportMutation,
  useGetServiceCaseIntegrationsEvaClaimAdditionalInformationQuery,
  usePatchServiceCaseIntegrationsEvaClaimAdditionalInformationMutation,
} = metadaWorkshopIntegrationApi;
